import { CompanyConstants } from '../constants';

export const setCompanyDetails = (payload) => {
  // window.localStorage.setItem('companyDetails', JSON.stringify(payload || ''));
  return {
    type: CompanyConstants.SET_COMPANY_DETAILS,
    payload
  };
};